import { useState } from 'react';

import {
   Col,
   Dropdown,
   DropdownItem,
   DropdownMenu,
   DropdownToggle,
   Input,
   Row,
} from 'reactstrap';

import { Href } from '../../../Utils/Constants';

interface Props {
   dropDownList: string[];
   onItemClick?: (item: string) => void;
   onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TableHeader = ({ dropDownList, onItemClick, onChange }: Props) => {
   const [dropdownOpen, setDropdownOpen] = useState(false);

   const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

   const handleItemClick = (item: string) => {
      if (onItemClick) {
         onItemClick(item);
      }
   };

   return (
      <Row
         className="align-items-center justify-content-between mb-3"
         style={{ paddingRight: '16px' }}
      >
         <Col xs="auto">
            <Input
               type="text"
               placeholder="Buscar..."
               className="form-control"
               style={{
                  width: '250px',
               }}
               onChange={onChange}
            />
         </Col>

         <Col xs="auto" className="me-2">
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
               <DropdownToggle
                  tag="span"
                  data-toggle="dropdown"
                  aria-expanded={dropdownOpen}
                  className="d-flex align-items-center"
                  style={{ cursor: 'pointer' }}
               >
                  <i className="fa-solid fa-grip-vertical"></i>
               </DropdownToggle>
               <DropdownMenu>
                  {dropDownList.map((item, index) => (
                     <DropdownItem
                        key={index}
                        href={Href}
                        onClick={() => handleItemClick(item)}
                     >
                        {item}
                     </DropdownItem>
                  ))}
               </DropdownMenu>
            </Dropdown>
         </Col>
      </Row>
   );
};
